var map = {
	"./aleris-eyes.json": 269,
	"./aleris-halmstad.json": 270,
	"./aleris-ortopedi-taby.json": 271,
	"./demo-clinic.json": 272,
	"./demo.json": 273,
	"./klarvy.json": 274,
	"./ocavis-ogonklinik.json": 275,
	"./ogonlasern-ogonklinik.json": 276,
	"./varda-goteborg.json": 277,
	"./varda.json": 278,
	"./x-vision-ogonklinik.json": 279
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 192;